export function addLocalStorage() {
  window.addEventListener("local_storage_save", (event) => {
    const { key, value } = event.detail;

    console.log(`Saving ${key} to local storage`);

    localStorage.setItem(key, value);
  });

  window.addEventListener("local_storage_load", (event) => {
    const { key, event_name } = event.detail;

    console.log(`Loading ${key} from local storage`);

    const savedValue = localStorage.getItem(key);

    window.dispatchEvent(new CustomEvent(event_name, { detail: { content: savedValue } }));
  });

  window.addEventListener("local_storage_delete", (event) => {
    const { key } = event.detail;

    console.log(`Removing ${key} from local storage`);

    localStorage.removeItem(key);
  });
}
